import React from 'react';
import ProductSlider from './ProductSlider';
import { icons } from '../../../../../shared/icons';
import noImage from '../slike/noImage.png';
import saleImg from '../slike/sale.png';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const MainProdavnica = ({
  deloviPregled,
  handleShopClick,
  handleOpenDetail,
  deloviPregledFavorite,
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div style={{ fontSize: '25px', fontWeight: 'bold', padding: '20px' }}>
        {t('favorite')}
      </div>
      <ProductSlider
        products={deloviPregledFavorite}
        handleShopClick={handleShopClick}
        handleOpenDetail={handleOpenDetail}
      />
      <div
        style={{
          fontSize: '25px',
          fontWeight: 'bold',
          padding: '20px',
          marginTop: '50px',
        }}
      >
        {t('equipmentParts')}
      </div>
      <div className="delovi-lista">
        {deloviPregled.map((product, index) => (
          <div
            key={index}
            className="deo-item"
            onClick={(e) => handleOpenDetail(e, product)}
          >
            <div style={{ padding: '15px', position: 'relative' }}>
              {product.akcija && (
                <img
                  src={saleImg}
                  alt="Sale"
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '50px',
                    height: '50px',
                  }}
                />
              )}
              <img
                className="product-slider"
                src={product.slikaUrl || noImage}
                alt={product.naziv}
                style={{ width: '100%', borderRadius: '11px' }}
              />
            </div>
            <div className="shop-data">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: '3px' }}>{product.naziv}</h3>
                <h3 style={{ margin: '3px' }}>
                  {t('partNumber')}: {product.partNumber}
                </h3>
                {product.rabat !== 0 && (
                  <div>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <div
                        style={{
                          backgroundColor: '#e00',
                          borderRadius: '4px',
                          color: '#fff',
                          width: '40px',
                          height: '20px',
                          textAlign: 'center',
                        }}
                      >
                        {product.rabat}%
                      </div>{' '}
                      <div style={{ fontWeight: 'bold', color: '#e00' }}>
                        <span style={{ fontWeight: '100' }}>
                          {t('saving')}:
                        </span>{' '}
                        {formatPrice(product.usteda)}{' '}
                        <span style={{ fontSize: '15px' }}>EUR</span>
                      </div>
                    </div>
                    <div
                      style={{
                        color: '#a0a0a0',
                        textDecoration: 'line-through',
                      }}
                    >
                      {formatPrice(product.prodajnaCena)}{' '}
                      <span style={{ fontSize: '15px' }}>EUR</span>
                    </div>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 style={{ margin: '3px' }}>
                    {formatPrice(product.fakturnaCena)}
                  </h3>{' '}
                  <span style={{ color: 'gray', fontWeight: '600' }}>EUR</span>
                </div>
              </div>
              <button
                className="shop-button"
                onClick={(e) => handleShopClick(e, product)}
              >
                {icons.SHOP_ICON}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainProdavnica;
